import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { AuthService } from 'app/services/auth.service';
import { ExpenseService } from 'app/services/models/expense.service';
import { KindService } from 'app/services/models/kind.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-expense-list',
  templateUrl: './expense-list.component.html',
  styleUrls: ['./expense-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExpenseListComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  public searchValue = '';
  totalCount: Number = 0;
  public ColumnMode = ColumnMode;
  constructor(
    private expenseService: ExpenseService,
    private router: Router,
    private _coreSidebarService: CoreSidebarService,
    public authService: AuthService
  ) { }

  async ngOnInit() {
    this.expenseService.event$.subscribe(async result => {
      await this.getAllExpenses(this.pageBasic - 1, this.selectedSize, this.searchValue);
    });
    await this.getAllExpenses(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }

  async getAllExpenses(page, size, search) {
    this.blockUI.start();
    const expenseAuthorizaton = this.authService.isEndpointStatus('GET.Reading.GetAllListExpense');
    if (expenseAuthorizaton) {
      const data = await this.expenseService.getAllExpense(page, size, search);
      console.log(data);
      this.rows = data.expenses;
      this.totalCount = data.totalCount;
    }
    this.blockUI.stop();
  }

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.searchValue = val;
    setTimeout(async () => {

      await this.getAllExpenses(this.pageBasic - 1, this.selectedSize, this.searchValue);
    }, 500);
  }

  async onPageChange(pageNumber: number) {
    await this.getAllExpenses(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption)
    await this.getAllExpenses(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }

  selectedExpense: any;
  toggleSidebar(name, row): void {
    this.selectedExpense = row;
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }
}